import { defaultIntegrationContactObject, defaultIntegrationMeetingExportObject, IntegrationServiceId } from '../../../../../common/integrations'
import { AccountIntegrationConfig, CRMAccountIntegrationConfig } from '../../../../../models/Account'
import { SERVICE_ID_TO_INTEGRATION_TYPE_MAPPING } from '../../../../../models/User'

export const defaultCRMAccountIntegrationConfig = (serviceId: IntegrationServiceId): CRMAccountIntegrationConfig => {
  const contactObject = defaultIntegrationContactObject[serviceId]
  const meetingExportObject = defaultIntegrationMeetingExportObject[serviceId]
  if (contactObject && meetingExportObject) {
    return {
      type: 'crm',
      serviceId,
      loginUrl: null,
      mappings: { contact: { objectName: contactObject }, session: { objectName: meetingExportObject.id } },
      enableNoteExport: true,
      enableFullMeetingExport: true,
      enableContactCreate: true,
      enableContactUpdate: true,
      isCustom: false,
      isSyncDisabled: false,
    }
  }
  return {
    type: 'crm',
    serviceId,
    loginUrl: null,
    mappings: {},
    enableNoteExport: true,
    enableFullMeetingExport: true,
    enableContactCreate: true,
    enableContactUpdate: true,
    isCustom: false,
    isSyncDisabled: false,
  }
}

export const defaultAccountIntegrationConfig = (serviceId: IntegrationServiceId): AccountIntegrationConfig => {
  if (SERVICE_ID_TO_INTEGRATION_TYPE_MAPPING[serviceId] === 'planning') {
    return { type: 'planning', serviceId, loginUrl: null, enableContactCreate: true, enableContactUpdate: true }
  }
  return defaultCRMAccountIntegrationConfig(serviceId)
}
